import { Injectable } from '@angular/core';
import { SessionStorage } from '../../core/services/global/storage/session-storage.service';
import { isNullOrUndefined } from 'util';

@Injectable()
export class NotificationStorageService {

  readonly NOTIFICATION_COMPONENT_KEY = 'NOTIFICATION_COMPONENT_KEY';
  readonly NOTIFICATION_REQUEST = 'NOTIFICATION_REQUEST';

  constructor(private _sessionStorage: SessionStorage) {
  }

  putNotification(componentKey: string, notification: any): void {
    this._sessionStorage.put(this.NOTIFICATION_COMPONENT_KEY, this._buildNotification(componentKey, notification))
  }

  putNotificationRequest() {
    this._sessionStorage.put(this.NOTIFICATION_REQUEST, true)
  }

  clearNotification(): void {
    this._sessionStorage.remove(this.NOTIFICATION_COMPONENT_KEY);
  }

  isNotificationRequest(): boolean {
    return !isNullOrUndefined(this._sessionStorage.get(this.NOTIFICATION_REQUEST))
      && (this._sessionStorage.get(this.NOTIFICATION_REQUEST) === true);
  }

  isNotification(): boolean {
    return !isNullOrUndefined(this._sessionStorage.get(this.NOTIFICATION_COMPONENT_KEY));
  }

  getNotification(): StorageNotification {
    return this._sessionStorage.get(this.NOTIFICATION_COMPONENT_KEY);
  }

  private _buildNotification(componentKey: string, notification: any): StorageNotification {
    return {componentKey: componentKey, notification: notification};
  }
}

export interface StorageNotification {
  componentKey: string,
  notification: any
}
